import { combineReducers } from "redux";

import employeesReducer from "./Employees/employees.reducer";
import clientsReducer from "./Clients/clients.reducer";
import messReducer from './MessManagement/mess.reducer'
import teamsReducer from "./Teams/teams.reducer";
import appSidebarReducer from "./AppSidebar/appSidebar.reducer";
import userManagmentReducer from "./UserManagment/userManagment.reducer";
import candidate from "./Candidates/candidates.reducer"
import jobPosting from "./jobPosting/jobPosting.reducer"
import interviewFeedback from "./interviewFeedback/interviewFeedback.reducer";
import login from "./Login/login.reducer";
import employeeEvaluation from "./EmployeeEvaluation/employeeEvaluation.reducer";
import helpDesk from './HelpDesk/helpDesk.reducer';
import attendance from './Attendance/attendance.reducer';
import projectReducer from "./Projects/projects.reducer"
import taskReducer from "./Tasks/task.reducer"
import timeReducer from "./TimeLogs/time.reducer"
import interviewReducer from "./interview/interview.reducer"

const rootReducer = combineReducers({
  employees: employeesReducer,
  clients: clientsReducer,
  teams: teamsReducer,
  appSidebar: appSidebarReducer,
  userManagment: userManagmentReducer,
  candidate: candidate,
  jobPosting:jobPosting,
  interviewFeedback:interviewFeedback,
  employeeEvaluation:employeeEvaluation,
  helpDesk:helpDesk,
  login:login,
  attendance:attendance,
  mess:messReducer,
  projects: projectReducer,
  tasks: taskReducer,
  time: timeReducer,
  interview: interviewReducer,
});

export default rootReducer;
